<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
      v-show="!overlay"
    >
      <v-card-title class="title font-weight-light">
        My Booking Details
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <div class="d-flex justify-space-between px-3">
        <div>
          <v-select
            v-model="selectedHeaders"
            :items="headersPools"
            label="Select Columns"
            multiple
            outlined
            return-object
            hide-details
            dense
            @change="handleChangeColumns"
          >
            <template #selection="{ item, index }">
              <v-chip v-if="index < 1">
                <span>{{ item.text }}</span>
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption"
              >(+{{ selectedHeaders.length - 1 }} Others)</span>
            </template>
          </v-select>
        </div>
        <v-checkbox
          v-model="showHistory"
          :label="`Show Historical Data`"
          class="mt-5"
          @click="handleShowHistory"
        />
      </div>
      <v-data-table
        :headers="showHeaders"
        :items="getBookData"
        item-key="book_id"
        class="font-weight-light"
        :loading="loadingBook"
        :footer-props="footerProps"
        @update:options="updatePaging"
        :server-items-length="bookTotal"
      >
        <template #top>
          <v-dialog
            v-model="dialog"
            max-width="600"
          >
            <v-card :height="showCostCode(selectedOrigin.book_detail) ? 550 : 600">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Booking Details</v-toolbar-title>
                <v-spacer />
                <v-btn
                  icon
                  color="error"
                  @click="dialog = false"
                >
                  <v-icon color="white">
                    mdi-close-box
                  </v-icon>
                </v-btn>
                <template #extension>
                  <v-tabs
                    v-model="tabs"
                    centered
                  >
                    <v-tab>
                      Booking Information
                    </v-tab>
                    <v-tab>
                      Passenger Information
                    </v-tab>
                  </v-tabs>
                </template>
              </v-toolbar>

              <v-tabs-items v-model="tabs">
                <v-tab-item>
                  <v-card
                    min-width="350px"
                    flat
                    class="ma-4"
                  >
                    <v-row class=" justify-center text-center">
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-btn
                          outlined
                          color="primary"
                          class="primary--text text-center"
                          dense
                          @click="handleEditBooking(selectedOrigin.book_detail)"
                          v-show="pastCondition(selectedOrigin.book_detail)"
                        >
                          Edit Booking
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-subheader>Schedule Information</v-subheader>
                    <div class="px-5 my-0 pb-2">
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-account
                        </v-icon>
                        <span>{{ selectedOrigin.username }}</span>
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-map-marker
                        </v-icon>
                        From
                        <b>
                          {{ getConfirmOriginName(selectedOrigin.book_detail) }}
                        </b>
                        To
                        <b>
                          <span>{{
                            getDestinationAddrs(selectedOrigin.book_detail)
                          }}</span>
                        </b>
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-car
                        </v-icon>
                        <span>
                          {{
                            getConfirmVehicleName(selectedOrigin.book_detail)
                          }}</span>
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-calendar-clock
                        </v-icon>
                        {{ getDates(selectedOrigin.book_detail) }}
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-clock-time-three-outline
                        </v-icon>
                        {{ getDuration(selectedOrigin.book_detail) }}
                      </div>
                      <div
                        class="my-5"
                        v-if="showCostCode(selectedOrigin.book_detail)"
                      >
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-currency-usd
                        </v-icon>
                        {{ getCostCode(selectedOrigin.book_detail) }}
                      </div>
                      <div class="my-5">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-map
                        </v-icon>
                        Car Park Location: {{ getCarParkLocation(selectedOrigin.book_detail) }}
                      </div>
                      <div class="my-5 ">
                        <v-icon
                          color="primary"
                          left
                        >
                          mdi-key
                        </v-icon>
                        Key Cabinet Location: {{ getKeCabinetLocation(selectedOrigin.book_detail) }}
                      </div>
                    </div>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card
                    flat
                    class="pa-4"
                  >
                    <v-simple-table class="ma-5 blue lighten-5">
                      <template #default>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Booked By</th>
                            <th>No of Occupants</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(passenger, i) in selectedOrigin.book_detail.passenger"
                            :key="i"
                          >
                            <td>{{ i + 1 }}</td>
                            <td>
                              {{
                                `${passenger.first_name} ${passenger.last_name}`
                              }}
                              <v-chip
                                x-small
                                class="ma-2"
                                color="primary"
                                dark
                                v-if="passenger.is_owner"
                              >
                                Owner
                              </v-chip>
                            </td>
                            <td>{{ passenger.passenger_count }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-dialog>
        </template>
        <template #loading>
          <span v-if="loadingBook && getBookData.length == 0">
            Loading
          </span>
          <span v-if="!loadingBook && getBookData.length == 0">
            There's no booking you've made, please <a :href="`${getCarpoolURL()}/#/book`">click here</a> to create booking.
          </span>
        </template>
        <template #no-data>
          There's no booking you've made, please <a :href="`${getCarpoolURL()}/#/book`">click here</a> to create booking.
        </template>
        <template #[`item.book_detail.start_geofence_id`]="{ item }">
          {{ getOriginName(item.book_detail) }}
        </template>
        <template #[`item.book_detail.vehicle_name`]="{ item }">
          {{ getVehicleName(item.book_detail) }}
        </template>
        <template #[`item.book_detail.end_geofence_id`]="{ item }">
          {{ getDestinationAddr(item.book_detail) }}
        </template>
        <template #[`item.book_detail.recurring`]="{ item }">
          <div v-if="item.book_detail.recurring == '1'">
            <v-tooltip
              bottom
              :open-delay="500"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  v-if="item.book_detail.recurring == '1'"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
              </template>
              <table v-if="item.book_detail.booking_recurring">
                <tbody>
                  <tr
                    v-for="r in item.book_detail.booking_recurring"
                    :key="r.id"
                  >
                    <td>{{ formatDate(r.start_datetime, 'ddd, D MMM YYYY HH:mm') }}</td>
                    <td> &nbsp; - &nbsp; </td>
                    <td>{{ formatDate(r.end_datetime, 'ddd, D MMM YYYY HH:mm') }}</td>
                  </tr>
                </tbody>
              </table>
            </v-tooltip>
          </div>
        </template>
        <template
          #[`item.action`]="{ item }"
          style="width : 100px;"
        >
          <div class="d-flex">
            <v-icon
              small
              @click="editItem(item)"
              color="primary"
            >
              mdi-eye
            </v-icon>
            <v-btn
              x-small
              rounded
              class="mx-2"
              @click="handleEditBooking(item.book_detail)"
              v-show="pastCondition(item.book_detail)"
              color="primary"
            >
              Edit
            </v-btn>
            <v-icon
              small
              @click="cancelBooking(item)"
              color="red"
              v-if="pastCondition(item.book_detail, true)"
            >
              mdi-delete
            </v-icon>
          </div>
        </template>
        <template #[`item.book_detail.start_datetime`]="{ item }">
          {{ startDateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.end_datetime`]="{ item }">
          {{ endDateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.created_at`]="{ item }">
          {{ formatDate(item.book_detail.created_at) }}
        </template>
        <v-data-footer />
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="dialogRecurring"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Schedule for Booking with ID {{ selectedBookId }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="headersSchedule"
                  :items="schedules"
                  :items-per-page="10"
                  class="elevation-1"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="dialogRecurring = false; clearSchedules()"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogRecurring = false; clearSchedules()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deldialog"
      persistent
      max-width="560"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
            this booking?
          </span>
        </v-card-title>
        <v-card-text>
          You will delete this booking permanently.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="deldialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            @click="submitDeleteBooking()"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */

const qs = require("qs");
import moment from "moment";
import isNull from "lodash/isNull";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import isUndefined from "lodash/isUndefined";

export default {
  data() {
    return {
      menu2: false,
      time: null,
      menu3: false,
      tabs: null,
      isPast: false,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      editedItem: {
        clientid: "",
        id: "",
        book_detail: {
          start_geofence_id: "",
          start_datetime: "",
          end_datetime: "",
        },
        passenger_count: "",
      },
      passenger_manifest: {
        email: "",
        name: "",
        phone: "",
        start_datetime: "",
        end_datetime: "",
        from: "",
        to: "",
      },
      dialog: false,
      chartOptions: {
        chart: {
          title: "Statistic for Most Used User",
          subtitle: "Admin, Dean, Dwiky, Superadmin",
        },
      },
      chartData: [],
      headersPools: [
        { text: "Booking ID", value: "book_detail.id" },
        { text: 'First Name', align: 'left', value: 'first_name' },
        { text: 'Last Name', align: 'left', value: 'last_name' },
        { text: "From", value: "book_detail.start_geofence_id" },
        { text: "To", value: "book_detail.end_geofence_id" },
        { text: "Start Date", value: "book_detail.start_datetime" },
        { text: "End Date", value: "book_detail.end_datetime" },
        { text: "Asset Name", value: "book_detail.vehicle_name" },
        {text: "Recurring", value: "book_detail.recurring", sortable: false},
        {text: "Created At", value: "book_detail.created_at"},
        { text: "Actions", value: "action", sortable: false },
      ],
      userChart: [],
      booked: 0,
      getBookData: [],
      getBookedData: [],
      getVehicles: [],
      no_passenger: "",
      responsive: true,
      getDevice: 0,
      deviceLoaded: false,
      chartNull: false,
      countDevice: 0,
      dataPool: [],
      dataPools: [],
      notBooked: 0,
      updatedVehicle: "",
      start: null,
      match: [],
      not_match: [],
      end: null,
      now: null,
      e1: 1,
      selectedOrigin: "",
      detailValidate: true,
      oriGeoId: "",
      parent_id: "",
      sharedBook: false,
      startDateTime: "",
      endDateTime: "",
      noPassenger: "",
      selectedVehicle: "",
      selectedAddr: "",
      setAddr: "",
      sharedVehicle: false,
      setDestination: "",
      selectedStartDate: "",
      selectedStartTime: "",
      showSuccess: false,
      setVehicleName: "",
      loader: null,
      snackbar: false,
      options: [],
      text: "LOADING ...",
      entries: [],
      items: [],
      isLoading: false,
      model: null,
      search: null,
      type_of_vehicle: [
        "Passenger Car 5 Seats",
        "Passenger Car 7-8 Seats",
        "Ute",
        "Other",
      ],
      center: { lat: -23.8511901, lng: 131.2038283 },
      zoom: 4,
      gmapOption: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      numberRule: (v) => {
        if (!v.trim()) return true;
        if (!isNaN(parseFloat(v)) && v >= 0 && v <= 99) return true;
        return "Number of passenger must to be more than 1";
      },
      oriPosition: { lat: 0, lng: 0 },
      chartsLib: null,
      availTl: "",
      gChartOptions: {
        timeline: {
          showRowLabels: false,
        },
        hAxis: {
          format: "HH:mm",
        },
        colors: ["#66bb6a", "#e57373"],
        width: 1055,
        height: 100,
        avoidOverlappingGridLines: false,
      },
      destPosition: null,
      vehicleId: null,
      setConfirmBook: [],
      token: this.$store.state.token,
      userId: this.$store.state.user.user.id,
      valid: true,
      selectRules: [(v) => !!v || "Item is required"],
      dateRules: [(v) => !!v || "Item is required"],
      destAddr: "",
      selectedId: "",
      endDateDialog: false,
      display: false,
      loadingBook: false,
      searchData: "",
      searchTimeout: null,
      bookTotal: 0,
      footerProps: {
        itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
      },
      paginationOptions: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 10
      },
      overlay: false,
      selectedBookId: null,
      dialogRecurring: false,
      recurringData: [],
      headersSchedule: [
        {
          text: 'Username',
          value: 'username',
          sortable: false,
        },
        {
          text: 'From',
          value: "start_geofence_id",
          sortable: false,
        },
        {
          text: 'To',
          value: "end_geofence_id",
          sortable: false,
        },
        {
          text: 'Start Date',
          value: "start_datetime",
          sortable: false,
        },
        {
          text: 'End Date',
          value: "end_datetime",
          sortable: false,
        },
        {
          text: 'Asset Name',
          value: "asset_name",
          sortable: false,
        },
      ],
      deldialog: false,
      deleteTarget: null,
      loadingUpdate: false,
      loader: null,
      assetTypes: [],
      showHistory: false,
      selectedHeaders: [],
    };
  },
  created() {
    //data booked
    this.$store.dispatch("GET_ALL_GEOFENCES");
    this.$store.dispatch("GET_GEOFENCES");

    //data for origin
    this.$store.dispatch("LOAD_POOL_DATA");
    this.getAllDevice();
    this.getDataVehicles();
    setTimeout(() => {
      this.$store.dispatch("LOAD_POOL_DATA");
    }, 1e3);
    this.overlay = true;
    if (localStorage.getItem("selectedHeaders")) {
      this.selectedHeaders = JSON.parse(localStorage.getItem("selectedHeaders"));
    } else {
      this.selectedHeaders = Object.assign([], this.headersPools);
    }
  },
  watch: {
    endDateTime(value) {
      if (this.startDateTime > value) {
        this.endDateDialog = true;
      }
    },
    searchData(value) {
      this.doSearch();
    },
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 2e3)
    },
    deldialog(show) {
      if (!show) {
        this.deleteTarget = null;
      }
    },
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
  },
  computed: {
    showHeaders () {
      return this.headersPools.filter(h => this.selectedHeaders.find(s => s.value === h.value));
    },
    fields() {
      if (!this.model) return [];
      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
    destination() {
      return this.entries.map((entry) => {
        const key = btoa(`${entry.address}-${entry.lat}-${entry.lng}`);
        return Object.assign({}, entry, { key });
      });
    },
    getPoolData() {
      return this.$store.getters.getPoolData;
    },
    getAvailVehicle() {
      return this.$store.getters.getVehiclesData;
    },
    getDestinationData() {
      return this.$store.getters.getDestinationData;
    },
    all_geofences() {
      return this.$store.getters["getAllGeofencesData"];
    },
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
    schedules() {
      return this.$store.getters['schedules'];
    },
    loadSchedule() {
      return this.$store.getters['loadSchedule'];
    }
  },
  mounted() {
    this.getBookTotal();
    this.getData();
    this.getAssetType();
    // this.getDataVehicles();
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    handleChangeColumns() {
      this.$nextTick(() => {
        localStorage.setItem('selectedHeaders', JSON.stringify(this.selectedHeaders));
      });
    },
    handleEditBooking(item) {
      this.dialog = false;
      this.$router.push({ path: `/book/${item.id}` });
    },
    getAssetType() {
      this.$store.dispatch('API_CALL', {
          $method: 'get_asset_types',
          $postData: {
            clientid: this.$store.state.clientid,
          },
        })
        .then((response) => {
          this.assetTypes = response.data.data;
        });
    },
    submitDeleteBooking() {
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      this.token = this.$store.state.token;
        this.$store.dispatch('API_CALL', {
            $method: 'delete_book',
            $postData: {
              book_id: this.deleteTarget.book_id,
            },
          })
          .then((response) => {
            if(response.data.code == 200) {
              this.deldialog = false
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              this.$swal({
                icon: "success",
                title: response.data.data.message,
              });
              Promise.all([
                this.getBookTotal(),
                this.getData(),
              ]).then(() => {
                // Total data ada, tapi di page ini kosong
                if (this.bookTotal > 0 && this.getBookData.length === 0) {
                  // reset page ke page 1
                  this.paginationOptions.page = 1
                  this.getBookTotal();
                  this.getData();
                }
              })
              // this.getBookData.splice(userIndex, 1);
            } else {
              this.$swal({
                icon: "error",
                title: response.data.data.message,
              });
            }
          });
    },
    getConfirmOriginName(selectedOrigin) {
      if (selectedOrigin == null) return;
      const metadata = this.getPoolData.find(
        (g) => g.Id == selectedOrigin.start_geofence_id
      );
      if (!metadata) return;
      return metadata.name;
    },
    getConfirmVehicleName(selectedOrigin) {
      if (selectedOrigin == null) return;
      let metadata = "";
      let getModel = "";
      if (!isNull(selectedOrigin.vehicle_name)) {
        getModel = this.getVehicles.find(
          (veh) => veh.id == selectedOrigin.vehicle_id
        )
        metadata = `${selectedOrigin.vehicle_name} - ${getModel.device_make} ${getModel.device_model.replace(
          /[^\w\s]/gi,
          ""
        )}`;
      } else if (!isNull(selectedOrigin.asset_id)) {
        const typeName = this.assetTypes.find((d) => d.id == selectedOrigin.asset_type);

        metadata = `${get(typeName, "name", "-")} - ${selectedOrigin.asset_number}`;
      } else {
        metadata = "--";
      }
      if (!metadata) return;
      return metadata;
    },
    getVehicleName(item) {

      if (item == null) return;
      let metadata = "";
      if (!isNull(item.vehicle_name)) {
        metadata = `Vehicle - ${item.vehicle_name}`;
      } else if (!isNull(item.asset_id)) {
        const typeName = this.assetTypes.find((d) => d.id == item.asset_type);

        metadata = `${get(typeName, "name", "-")} - ${item.asset_number}`;
      } else {
        metadata = "--";
      }
      if (!metadata) return;
      return metadata;
    },
    getDates(selectedOrigin) {
      if (selectedOrigin == null) return;
      if (selectedOrigin.hasOwnProperty("start_datetime")) {
        const start = moment(selectedOrigin.start_datetime, "YYYY-MM-DD");
        const end = moment(selectedOrigin.end_datetime, "YYYY-MM-DD");
        const duration = moment.duration(end.diff(start));
        const day = duration.days();
        if (day == 0) {
          if (start == moment().format("YYYY-MM-DD")) {
            return "Today";
          } else {
            return `${start.format("D MMM YYYY")}`;
          }
        } else {
          return `${start.format("D")} \u2014 ${end.format("D")} ${start.format(
            "MMM YYYY"
          )}`;
        }
      }
    },
    getDuration(selectedOrigin) {
      if (selectedOrigin == null) return;
      if (selectedOrigin.hasOwnProperty("start_datetime")) {
        const start = moment(selectedOrigin.start_datetime).format("HH:mm");
        const end = moment(selectedOrigin.end_datetime).format("HH:mm");
        return `${start} \u2014 ${end}`;
      }
    },
    showCostCode(bookDetail) {
        let show = false;
        let metadata = {};
        try {
          metadata = JSON.parse(get(bookDetail, 'metadata', ''));
        } catch(e) {}
        if (metadata.hasOwnProperty('cost_code')) {
          if (metadata.cost_code) {
            show = true;
          }
        }
        return show;
      },
      getCostCode(bookDetail) {
        let costCode = '';
        let metadata = {};
        try {
          metadata = JSON.parse(get(bookDetail, 'metadata', ''));
        } catch(e) {}
        if (metadata.hasOwnProperty('cost_code')) {
          if (metadata.cost_code) {
            costCode = metadata.cost_code;
          }
        }
        return costCode;
      },
      getCarParkLocation(bookDetail) {
        if (bookDetail && bookDetail.vehicle_id) {
          const vehicle = this.getVehicles.find((v) => v.id == bookDetail.vehicle_id);
          if (vehicle) {
            return get(vehicle, 'metadata.parking_location', '');
          }
        }
        return '';
      },
      getKeCabinetLocation(bookDetail) {
        if (bookDetail && bookDetail.vehicle_id) {
          const vehicle = this.getVehicles.find((v) => v.id == bookDetail.vehicle_id);
          if (vehicle) {
            return get(vehicle, 'cabinet_name', '');
          }
        }
        return '';
      },
    getDestinationAddrs(selectedOrigin) {
      if (selectedOrigin == null) return;
      let metadata = "";
      if (selectedOrigin.hasOwnProperty("metadata")) {
        metadata = selectedOrigin.metadata;
        if (metadata == "[]") {
          const metadata = this.getDestinationData.find(
            (g) => g.Id == selectedOrigin.end_geofence_id
          );
          if (!metadata) return;
          return metadata.name;
        } else {

          const metadata = JSON.parse(selectedOrigin.metadata);
          return metadata.address;
        }
      }
    },
    startDateFormat(item) {
      if (item == null) return;
      let date = null;
      if (item.hasOwnProperty("start_datetime")) {
        date = moment(item.start_datetime).format('ddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    endDateFormat(item) {
      if (item == null) return;
      let date = null;
      if (item.hasOwnProperty("end_datetime")) {
        date = moment(item.end_datetime).format('ddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    formatDate(date, format = 'D MMM YYYY HH:mm') {
      if (date == null) return;
      const dateFormatted = moment(date).format(format)
      return dateFormatted;
    },
    getBookTotal() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      const skip_past_date = this.showHistory ? 0 : 1;
      if (this.$store.state.type == 3) {
        return this.$store.dispatch('API_CALL', {
            $method: 'get_book_total',
            $postData: {
              status: 2,
              query: this.searchData,
              get_schedules: 0,
              skip_past_date
            },
          })
          .then((response) => {
            this.bookTotal = parseInt(response.data.data.total);
          });
      } else if (this.$store.state.type == 2 || this.$store.state.type == 4) {
        return this.$store.dispatch('API_CALL', {
            $method: 'get_book_total',
            $postData: {
              user_id: this.$store.state.user.user.id,
              clientid: this.$store.state.clientid,
              status: 2,
              query: this.searchData,
              get_schedules: 0,
              skip_past_date
            },
          })
          .then((response) => {
            this.bookTotal = parseInt(response.data.data.total);
          });
      } else if (this.$store.state.type == 1) {
        return this.$store.dispatch('API_CALL', {
            $method: 'get_book_total',
            $postData: {
              clientid: this.$store.state.clientid,
              status: 2,
              query: this.searchData,
              get_schedules: 0,
              skip_past_date
            },
          })
          .then((response) => {
            this.bookTotal = parseInt(response.data.data.total);
          });
      }
    },
    getData() {
      if (this.loadingBook) return;
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.loadingBook = true;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by  = sortBy.length ? sortBy[0] : 'book_detail.created_at';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'desc';
      const offset   = (page - 1) * itemsPerPage;

      let by = 'book_id';

      switch(sort_by) {
        case 'book_detail.id':
            by = 'book_id';
            break;
        case 'first_name':
            by = 'first_name';
            break;
        case 'last_name':
            by = 'last_name';
            break;
        case 'book_detail.start_geofence_id':
            by = 'origin';
            break;
        case 'book_detail.vehicle_name':
            by = 'asset';
            break;
        case 'book_detail.start_datetime':
            by = 'start_date';
            break;
        case 'book_detail.end_datetime':
            by = 'end_date';
            break;
        case 'book_detail.created_at':
            by = 'created_at';
            break;
        default:
          break;
      }

      const skip_past_date = this.showHistory ? 0 : 1;

      if (this.$store.state.type == 3) {
        return this.$store.dispatch('API_CALL', {
            $method: 'get_all_book',
            $postData: {
              clientid: this.$store.state.clientid,
              limit: itemsPerPage,
              offset,
              sort_by: by,
              sort_dir,
              query: this.searchData,
              status: 2,
              get_schedules: 0,
              get_recurring: 1,
              skip_past_date
            },
          })
          .then((response) => {
            this.loadingBook = false;
            this.getBookData = response.data.data.filter(
              (booking) => {
                return booking.book_detail.status == 2;
              }
            );
          });
      } else if (this.$store.state.type == 2 || this.$store.state.type == 4) {
        return this.$store.dispatch('API_CALL', {
            $method: 'get_all_book',
            $postData: {
              user_id: this.$store.state.user.user.id,
              clientid: this.$store.state.clientid,
              limit: itemsPerPage,
              offset,
              sort_by: by,
              sort_dir,
              query: this.searchData,
              status: 2,
              get_schedules: 0,
              get_recurring: 1,
              skip_past_date
            },
          })
          .then((response) => {
            this.loadingBook = false;
            this.getBookData = response.data.data.filter(
              (booking) => {
                return booking.book_detail.status == 2;
              }
            );
          });
      } else if (this.$store.state.type == 1) {
        return this.$store.dispatch('API_CALL', {
            $method: 'get_all_book',
            $postData: {
              clientid: this.$store.state.clientid,
              limit: itemsPerPage,
              offset,
              sort_by: by,
              sort_dir,
              query: this.searchData,
              status: 2,
              get_schedules: 0,
              get_recurring: 1,
              skip_past_date
            },
          })
          .then((response) => {
            this.loadingBook = false;
            this.getBookData = response.data.data.filter(
              (booking) => {
                return booking.book_detail.status == 2;
              }
            );
            let selectStart = moment("2021-04-20").unix();
            let selectEnd = moment("2021-04-22").unix();
            const schedules = this.getBookData.filter((schedule) => {
              let start = moment(schedule.book_detail.start_datetime).format("YYYY-MM-DD");
              let startUnix = moment(start).unix();
              let end = moment(schedule.book_detail.end_datetime).format("YYYY-MM-DD");
              let endUnix = moment(end).unix();
              return startUnix >= selectStart && endUnix <= selectEnd;
            });
          });
      }
    },
    getDataVehicles() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
          $method: 'get_vehicles',
          $postData: {
            clientid: this.clientid,
          },
        })
        .then((response) => {
          this.getVehicles = response.data.data;
          this.getDevice = response.data.data.length;
          this.deviceLoaded = true;
        });
    },
    pastCondition(item, isDelete = false) {
      if (!item) return false;
      const isRecurring = item.hasOwnProperty('booking_recurring');
      const now = moment().unix();
      let end = moment(item.end_datetime).unix();
      if (isRecurring) {
        if (item.booking_recurring.length > 0) {
          const recurring = item.booking_recurring;
          const lastRecurring = recurring[recurring.length - 1];
          end = moment(lastRecurring.end_datetime).unix();
        }
      }
      if (end > now) return true;
      return false;
    },
    sameUser(item) {
      if(item.created_by === this.$store.state.user.user.id) {
        return true
      } else {
        return false
      }
    },
    cancelBooking(item) {
      this.deldialog = true;
      this.deleteTarget = item;
    },
    onDelete(book_id) {
      this.clientid = this.$store.state.clientid;
      this.token = this.$store.state.token;
    },
    getVehicleId(vehicles) {
      if (!vehicles) return;
      this.vehicleId = vehicles.id;
      if (vehicles.hasOwnProperty("vehicle_name")) {
        this.setVehicleName = vehicles.vehicle_name;
      } else if (vehicles.hasOwnProperty("name")) {
        this.setVehicleName = vehicles.name;
      }
      this.e1 = 3;
    },
    editItem(item) {
      this.editedItem.passenger_count = item.passenger_count;
      this.selectedId = item.book_id;
      this.dialog = true;
      this.selectedOrigin = { ...item };
      let metadata = [];
      try {
        metadata = JSON.parse(item.book_detail.metadata);
      } catch (e) {}

      if (metadata.hasOwnProperty("address")) {
        this.selectedAddr = metadata.address;
        this.setDestination = {
          type: "address",
          latitude: item.book_detail.end_latitude,
          longitude: item.book_detail.end_longitude,
        };
        const lat = parseFloat(this.setDestination.latitude);
        const lat2 = parseFloat(item.book_detail.start_latitude);
        const lng = parseFloat(this.setDestination.longitude);
        this.destPosition = { lat, lng };
        this.center = { lat2, lng };
      } else {
        this.setDestination = {
          type: "geofence",
          geofence_id: item.book_detail.end_geofence_id,
        };
        const geo = this.getDestinationData.find(
          (g) => g.Id == item.book_detail.end_geofence_id
        );
        if (!geo) return;
        this.selectedAddr = geo.name;
        const lat = (parseFloat(geo.top) + parseFloat(geo.bottom)) / 2;
        const lng = (parseFloat(geo.left) + parseFloat(geo.right)) / 2;

        const geo2 = this.getPoolData.find(
          (g) => g.Id == item.book_detail.start_geofence_id
        );
        if (!geo2) return;
        const lat2 = (parseFloat(geo2.top) + parseFloat(geo2.bottom)) / 2;
        this.destPosition = { lat, lng };
        this.center = { lat2, lng };
      }
      this.editedItem = this.selectedOrigin;
      this.startDateTime = moment(
        this.editedItem.book_detail.start_datetime
      )._d;
      this.endDateTime = moment(this.editedItem.book_detail.end_datetime)._d;
      this.selectedVehicle = this.getVehicles.find(
        (g) => g.id == this.editedItem.book_detail.vehicle_id
      );
      this.selectedStartDate = moment(
        this.editedItem.book_detail.start_datetime
      ).format("YYYY-MM-DD");
      this.selectedStartTime = moment(
        this.editedItem.book_detail.start_datetime
      ).format("HH:mm");
    },
    getOriginName(item) {
      if (item == null) return;
      let destination = "";
      if (item.start_geofence_id != 0) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach((group) => {
              const geofenceDestination = group.geofences.find(
                (geofence) =>
                  parseInt(geofence.Id) === parseInt(item.start_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach((group) => {
            const geofenceDestination = group.geofences.find(
              (geofence) =>
                parseInt(geofence.Id) === parseInt(item.start_geofence_id)
            );
            if (!isUndefined(geofenceDestination)) {
              destination = geofenceDestination.name;
            }
          });
        }
      }
      return destination;
    },
    getTypeName(vehicles) {
      if (vehicles == null) return;
      const metadata = this.getVehicles.find(
        (g) => g.id == vehicles.id
      );
      if (!metadata) return;
      return metadata.type_name;
    },
    getDestinationAddr(item) {
      if (item == null) return;
      let destination = "";
      let stopFind = false;
      if (item.end_geofence_id != 0 && !isEmpty(item.end_geofence_id)) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach((group) => {
              if (stopFind === false) {
                const geofenceDestination = group.geofences.find(
                  (geofence) =>
                    parseInt(geofence.Id) === parseInt(item.end_geofence_id)
                );
                if (!isUndefined(geofenceDestination)) {
                  destination = geofenceDestination.name;
                  stopFind = true;
                }
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach((group) => {
            if (stopFind === false) {
              const geofenceDestination = group.geofences.find(
                (geofence) =>
                  parseInt(geofence.Id) === parseInt(item.end_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
                stopFind = true;
              }
            }
          });
        }
      }
      else if (isNull(item.end_geofence_id)) {
        const destination = JSON.parse(item.metadata);
        return destination.address;
      }
      else if (item.metadata && item.metadata.hasOwnProperty("address")) {
        destination = item.metadata.hasOwnProperty("address")
          ? item.metadata.address
          : `${item.start_longitude},${item.end_longitude}`;
      }
      else {
        const destination = JSON.parse(item.metadata);
        return destination.address;
      }
      return destination;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 1024) {
        this.responsive = false;
      } else {
        this.responsive = true;
      }
    },
    getAllDevice() {
      this.token = this.$store.state.token;
      this.deviceLoaded = false;
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
          $method: 'get_all_device',
          $postData: {
            clientid: this.clientid,
          },
        })
        .then((response) => {
          const getData = response.data.data;
          // this.getDevice = getData.length
          // this.deviceLoaded = true
        });
    },
    getAddress(item) {
      const data = JSON.parse(item.metadata);
      return data.created_date;
    },
    updatePaging(options) {
      this.getBookTotal();
      this.paginationOptions = options;
      this.getData();
    },
    doSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.getBookTotal();
        this.getData();
      }, 1e3)
    },
    loadRecurringData(bookId) {
      this.selectedBookId = bookId;
      this.$store.commit('CLEAR_SCHEDULES');
      this.$store.dispatch('LOAD_SCHEDULES', {
        token: this.$store.state.token,
        book_id: bookId
      })
    },
    clearSchedules() {
      this.selectedBookId = null;
      this.$store.commit('CLEAR_SCHEDULES');
    },
    // getOriginName(item) {
    //   if (item == null) return
    //   const metadata = this.getPoolData.find(g => g.Id == 'Depot 1')
    //   if (!metadata) return
    //   return metadata.name
    // },
    getCarpoolURL() {
      return process.env.VUE_APP_CARPOOLING_URL;
    },
    handleShowHistory() {
      this.getBookTotal();
      this.getData();
    }
  }
};
</script>
<style lang="css" scoped>
  .v-sheet--offset {
    top: -24px;
    position: relative;
    border-radius: 14px;
  }
  .text-class{
    top: -10px;
  }
  .text-offset{
    bottom: -24px;
  }
  .icon-clas{
    top: -15px;
  }
  .custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.vs__search {
  height: 45px;
}
.vs {
  color: #ff5252 !important;
  border: 2px solid #ff5252 !important;
  border-radius: 5px;
  font-size: 400 15.3333px Arial;
}
.noerror {
  border-radius: 5px;
  font-size: 400 15.3333px Arial;
}
</style>
<style>
.swal2-title {
  padding: 17px;
  display: block;
  margin: 22px;
  text-align: center;
  color: #61534e;
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-text {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-content {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
  text-align: center;
  color: #61534e;
}
.swal2-html {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-input {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-cancel {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-confirm {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.v-chip.v-size--default {
  height: 20px;
}
</style>
